import { render } from "./CompanyIntro.vue?vue&type=template&id=3e830b55"
import script from "./CompanyIntro.vue?vue&type=script&lang=js"
export * from "./CompanyIntro.vue?vue&type=script&lang=js"

import "./CompanyIntro.vue?vue&type=style&index=0&id=3e830b55&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__